import React from "react"
import { NextSeo } from "next-seo"

import { PARKING_FLOW_TYPE } from "~/utilities/constants"

import Layout from "~/components/parking/Layout"
import Landing from "~/components/parking/Landing"

class ParkingBothFlowPage extends React.Component {
  static async getInitialProps(ctx) {
    if (ctx.store && ctx.store.parkingFlow.flow.setEntryType) {
      ctx.store.parkingFlow.flow.setEntryType(PARKING_FLOW_TYPE.both)
      await ctx.store.plates.loadIfNecessary()
    }
    return {}
  }

  componentDidMount() {
    this.scrollUp()
  }

  scrollUp = () => {
    if (process.browser) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  render() {
    return (
      <>
        <NextSeo
          title="Fight or pay your New York City parking tickets | WinIt"
          description="Fight or pay your New York City parking tickets with WinIt. We fight for you, so you can save time and money. Download the WinIt app today."
          canonical="https://www.appwinit.com/parking/submit"
          additionalMetaTags={[
            {
              property: "description",
              content:
                "Fight or pay your New York City parking tickets with WinIt. We fight for you, so you can save time and money. Download the WinIt app today.",
            },
          ]}
        />
        <Layout>
          <Landing />
        </Layout>
      </>
    )
  }
}

export default ParkingBothFlowPage
